module.exports = __webpack_public_path__ + "media/images/calendar-58630a2629f27c971c760058e9f9848161215bb923175e4f1828df26b9f13e9e.svg";